export default __webpack_public_path__ + "static/media/Link of the Other World.acaf9d16.jpg";